import { css } from '@emotion/react';
import { FieldobjectGrid } from './_mixin.mixin';

export default $ => css`
  @media (min-width: 768px) {
    .smallTwoRows.default-all-row > * > * {
      grid-column-start: 1;
      grid-column-end: 4;
    }

    ${new FieldobjectGrid('smallOneRow', 1).include($)};
    ${new FieldobjectGrid('smallTwoRows', 2).include($)};
    ${new FieldobjectGrid('smallThreeRows', 3).include($)};
    ${new FieldobjectGrid('smallFourRows', 4).include($)};
    ${new FieldobjectGrid('smallFiveRows', 5).include($)};

    ${new FieldobjectGrid('grid-1-columns', 1).include($)};
    ${css([1, 2, 3, 4, 5].map(i => new FieldobjectGrid(`grid-${i}-columns`, i).include($)))};
  }
`;
